import { Toast } from "primereact/toast";
import { useRef, useState } from "react";

import { Form } from "./Form";
import { Table } from "./Table";
import useToggle from "../../hooks/useToggle";
import { IItinerary } from "../../models/BaseModel";
import { EditForm } from "./EditForm";

export interface IOpenForm {
    open: boolean,
    destination: string,
    packageTitle: string,
    packageDuration: number,
    cityId: number,
    singleData: IItinerary
}

export const Itinerary = ({ hasPermission }: { hasPermission: (pageName: string, featureName?: string) => boolean }) => {

    const [modal, setModal] = useState({ singleData: {}, open: false } as IOpenForm);
    const [reload, reloadData] = useToggle();
    const [editModal, setEditModal] = useState({ singleData: {}, open: false } as IOpenForm); // single edit

    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: {}, open: false, packageDuration: 0, cityId: 0, destination: '', packageTitle: '' });
    };

    const hideEditDialog = () => {
        setEditModal({ singleData: {}, open: false, packageDuration: 0, cityId: 0, destination: '', packageTitle: '' });
    };


    return (
        <>
            {(hasPermission("Itinerary", "Add") || hasPermission("Itinerary", "Edit")) && <Form destination={modal.destination} packageTitle={modal.packageTitle} packageDuration={modal.packageDuration} cityId={modal.cityId} hasPermission={hasPermission} singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reloadData={reloadData}></Form>}
            {hasPermission("Itinerary", "Edit") &&
                <EditForm {...editModal} hideDialog={hideEditDialog} toast={toast} reloadData={reloadData} hasPermission={hasPermission} />
            }
            <Table hasPermission={hasPermission} setModal={setModal} setEditModal={setEditModal} toast={toast} reload={reload} reloadData={reloadData}></Table>
            <Toast ref={toast} />
        </>
    );
}
